import styled from "styled-components";

export const EditCampaignDataModalWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  background-color: var(--primary-dark-600);
  color: var(--primary-white);
  padding: 18px 18px 21px 36px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.h1`
  color: var(--primary-dark-300);
  font-size: var(--fs-sm);
  font-weight: 400;
  line-height: var(--lh-sm);
`;

export const WarningContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 90%;
  padding: 12px 10px 15px 10px;
  gap: 10px;
  border-radius: 8px;
  background: var(--primary-yellow-50);
`;

export const WarningText = styled.p`
  color: var(--primary-dark-600);
  font-size: var(--fs-base);
  font-weight: 500;
  line-height: var(--lh-base);
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-dark-500);
  color: var(--primary-white);
  padding: 7px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 50%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  background-color: var(--primary-dark-50);
  color: var(--primary-dark-300);
  padding: 24px 150px 30px 36px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const ContentTitle = styled.span`
  color: var(--primary-dark-300);
  font-size: var(--fs-base);
  font-weight: 400;
  line-height: var(--lh-base);
`;

export const TextInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background: var(--primary-white);
  padding: 10px 20px;

  overflow: hidden;
  color: var(--primary-dark-600);
  font-size: var(--fs-base);
  font-weight: 600;
  line-height: var(--lh-base);
`;
